import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Typography } from "@mui/joy";

export type BottomNavTab = "saved" | "search" | "feed";

type BottomNavBarProps = {
  activeTab: BottomNavTab;
  onSavedClick: () => void;
  onSearchClick: () => void;
  onFeedClick: () => void;
};

const NAV_HEIGHT = 56;

export const BOTTOM_NAV_HEIGHT = NAV_HEIGHT;

export const BottomNavBar = ({
  activeTab,
  onSavedClick,
  onSearchClick,
  onFeedClick,
}: BottomNavBarProps) => {
  const tabs = [
    {
      key: "saved" as const,
      label: "Saved",
      icon: <BookmarkBorderIcon />,
      onClick: onSavedClick,
    },
    {
      key: "search" as const,
      label: "Search",
      icon: <SearchIcon />,
      onClick: onSearchClick,
    },
    {
      key: "feed" as const,
      label: "Feed",
      icon: <DynamicFeedIcon />,
      onClick: onFeedClick,
    },
  ];

  return (
    <Box
      data-testid="mobile-bottom-nav"
      sx={(theme) => ({
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: `${NAV_HEIGHT}px`,
        zIndex: 1200,
        backgroundColor: theme.vars.palette.background.surface,
        borderTop: `1px solid ${theme.vars.palette.divider}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        // Safe area inset for iOS notch/home indicator
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
      })}
    >
      {tabs.map((tab) => (
        <Button
          key={tab.key}
          variant="plain"
          color={activeTab === tab.key ? "primary" : "neutral"}
          onClick={tab.onClick}
          data-testid={`mobile-nav-${tab.key}`}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0,
            minWidth: 0,
            flex: 1,
            borderRadius: 0,
            py: 0.5,
          }}
        >
          {tab.icon}
          <Typography
            level="body-xs"
            color={activeTab === tab.key ? "primary" : "neutral"}
          >
            {tab.label}
          </Typography>
        </Button>
      ))}
    </Box>
  );
};
